import { css } from '@emotion/react'
import { ComponentPropsWithoutRef } from 'react'

import { colors } from '@/theme/variables'

interface Props extends ComponentPropsWithoutRef<'table'> {
  data: {
    columns: string[]
    data: { [key: string]: string }[]
  }
}

export const TimelineTable = ({
  data,
  ...props
}: Props): JSX.Element => {
  const styles = {
    container: css`
      overflow: scroll;
      width: var(--grid-w);
      padding: 0 var(--margin);
      box-sizing: border-box;
    `,
    table: css`
      width: 100%;
      min-width: fit-content;
      display: grid;
      grid-template-columns: repeat(${data?.columns.length}, auto);
      font-size: var(--fs-18);
      thead,
      tbody {
        display: contents;
      }
      tr {
        display: contents;
        text-align: left;
      }
      th,
      td {
        display: flex;
        align-items: flex-start;
        padding: 2em;
        &:nth-of-type(even) {
          background: rgba(0, 0, 0, 0.03);
        }
        &:not(:first-of-type) {
          text-align: center;
          justify-content: center;
        }
      }
      thead {
        th {
          border-bottom: 2px solid ${colors.red};
          padding-bottom: 1em;
          align-items: flex-end;
        }
      }
      tbody {
        td {
          border-bottom: 1px solid rgba(0, 0, 0, 0.1);
          &:nth-of-type(1) {
            font-weight: 550;
          }
        }
        tr:last-of-type {
          td {
            border-bottom: none;
          }
        }
      }
    `,
  }
  return (
    <div css={styles.container}>
      <table
        css={styles.table}
        {...props}
      >
        <thead>
          <tr>
            {data?.columns?.map((heading, i) => (
              <th key={i}>{heading}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {data?.data?.map((row, i) => (
            <tr key={i}>
              {Object.values(row).map((value, ii) => (
                <td
                  data-type={data?.columns[ii]}
                  key={ii}
                >
                  {value}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )
}
